import React from "react";

const PrivacyIntroduction = () => {
  return (
    <div className="mb-8">
      <p className="mb-8">
        We know that in this digital age, your privacy is important. This Privacy Policy reflects our commitment to protect personal data and the choices we offer you regarding how your data is used. We welcome you to read more about how we keep your information safe, as well as how you can exercise your rights. In addition, our Privacy policy covers our treatment of data that may be personal to you.
      </p>
      <div className="mb-8">
        <p>
          We will review, update, and amend these policies from time to time consistent with our business needs and technology. We encourage you to check back periodically for new updates or changes. Your continued use of the service makes up your acceptance of any change to this Privacy Policy. We are the data controller of your information. We handle and process all data on behalf of our customers.
        </p>
        <p>
          You may likewise decide not to give us "discretionary" Personal Data; however please remember that without it, we will most likely be unable to provide you with the full scope of our administrations or with the best client experience when utilizing our Services.
        </p>
      </div>
    </div>
  );
};

export default PrivacyIntroduction;